module.exports = __webpack_public_path__ + "static/img/nav6.b33693f6.svg";